import type { FinancialParams } from '../../../shared/api/models'

export function financialQuery(params: FinancialParams) {
  const query = new URLSearchParams({ month: params.month, timeZone: params.timeZone })
  if (params.filter) query.set('filter', params.filter)
  if (params.limit != null) query.set('limit', String(params.limit))
  if (params.cursor) query.set('cursor', params.cursor)
  return query
}
